import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import ModuleScheduleEditForm from './ModuleScheduleEditForm';
import ModuleScheduleEditDialogHeader from './ModuleScheduleEditDialogHeader';

const ModuleScheduleEditDialog = ({ show, onHide, id, isEdit, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: `Manage Schedule Add/Edit`,
    hide: onHide,
  });

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-edit-dialog"
    >
      <ModuleScheduleEditDialogHeader modal={modal} />
      <ModuleScheduleEditForm modal={modal} isEdit={isEdit} id={id ? +id : ''} />
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(ModuleScheduleEditDialog);
